import Box from "./Box";
import Image from "./Image";
import React from "react";

function ResponsiveImage({ image, resizeRule, pb }) {
  return (
    <Box height={0} pb={pb} position="relative">
      <Image
        src={image.url}
        alt={image.title}
        position="absolute"
        height="100%"
        width="100%"
        objectFit="cover"
        zIndex={2}
      />
      <Box position="absolute" bg="lightGrey" height="100%" width="100%" />
    </Box>
  );
}

export default ResponsiveImage;
